import { render } from "./official-login.vue?vue&type=template&id=2d034766&scoped=true&ts=true"
import script from "./official-login.vue?vue&type=script&lang=ts"
export * from "./official-login.vue?vue&type=script&lang=ts"

import "./official-login.vue?vue&type=style&index=0&id=2d034766&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d034766"]])